<template>
  <!-- Desktop modal -->
  <BaseModal
    v-if="!isMobile"
    name="RequiredAction"
    :visible="visible"
    :closeOutside="false"
    close-button
    :style="{ width: '560px' }"
    @close="onClose"
  >
    <component
      :is="modalComponent"
      @resolve="(response) => $emit('resolve', response)"
      @reject="(reason) => $emit('reject', reason)"
      @close="$emit('close')"
      v-bind="props"
    />
  </BaseModal>

  <!-- Mobile bottom sheet -->
  <BottomSheet
    v-else
    :visible="visible"
    :show-close-button="true"
    :close-on-backdrop="false"
    @close="onClose"
  >
    <component
      :is="modalComponent"
      @resolve="(response) => $emit('resolve', response)"
      @reject="(reason) => $emit('reject', reason)"
      @close="$emit('close')"
      v-bind="props"
    />
  </BottomSheet>
</template>

<script>
import BaseModal from '@emcd-shared/base-modal/BaseModal.vue'
import BottomSheet from '@/widgets/ModalPaymentLink/ui/components/BottomSheet.vue'
import { ref, nextTick, onMounted, onUnmounted } from 'vue'
import AnalyticsService from '@emcd-shared/analytics-service'

const handleKeyDown = (e) => e.key === 'Escape' && e.preventDefault()
const disableEsc = () => document.addEventListener('keydown', handleKeyDown)
const enableEsc = () => document.removeEventListener('keydown', handleKeyDown)

export default {
  name: 'ModalWrapper',
  components: { BaseModal, BottomSheet },
  props: ['modalComponent', 'props', 'onOpen'],
  emits: ['close', 'resolve', 'reject', 'open'],
  setup(props, { emit }) {
    const isMobile = ref(window.innerWidth < 640)
    const visible = ref(false)

    function checkMobile() {
      isMobile.value = window.innerWidth < 640
    }

    const onClose = () => {
      AnalyticsService.track('click', {
        button_name: '2fa_close',
        screen: '2fa',
        product: '',
        event_content: {
          type: 'required_user_action_modal',
        },
      })
      enableEsc()
      window.dispatchEvent(new CustomEvent('auth:2fa-modal-closed'))
      emit('close')
    }

    onMounted(async () => {
      await nextTick()
      visible.value = true
      disableEsc()
      window.addEventListener('resize', checkMobile)
      if (props.onOpen) props.onOpen()
      window.dispatchEvent(new CustomEvent('auth:2fa-modal-opened'))
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkMobile)
      window.dispatchEvent(new CustomEvent('auth:2fa-modal-closed'))
    })

    return {
      visible,
      isMobile,
      onClose,
    }
  },
}
</script>
